import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxDataWidgetComponent, OnyxDatePipe } from '@onyx/angular';
import { DiffPipe } from '../../../../../../../common/pipes/diff.pipe';
import { DurationPipe } from '../../../../../../../common/pipes/duration.pipe';
import { OrderHelper } from '../../../../../common/helpers/order.helper';
import type { Order } from '../../../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-plan-duration',
  imports: [
    OnyxDataWidgetComponent,
    TranslatePipe,
    DiffPipe,
    DurationPipe,
    OnyxDatePipe,
  ],
  templateUrl: './order-modal-plan-duration.component.html',
  styleUrl: './order-modal-plan-duration.component.scss',
})
export class OrderModalPlanDurationComponent {
  public readonly order = input.required<Order>();

  protected readonly I18N = 'orders.orderModal.plan';

  protected firstPointData = computed(() => this.durationData().firstPoint);
  protected lastPointData = computed(() => this.durationData().lastPoint);

  protected isOrderFinished = computed(() =>
    OrderHelper.isFinished(this.order().status.value),
  );

  private durationData = computed(() =>
    OrderHelper.getDurationData(this.order()),
  );
}
